export const APP_CONSTANT = {
    INIT_APP: 'INIT_APP',
    SHOW_LOADING: 'SHOW_LOADING',
    HIDE_LOADING: 'HIDE_LOADING',
    CHANGE_HOME_PAGE: 'CHANGE_HOME_PAGE',
    LOAD_ISSUE_LISTING: 'LOAD_ISSUE_LISTING',
    ADD_ISSUE_COLLECTOR_IN_LISTING: 'ADD_ISSUE_COLLECTOR_IN_LISTING',
    UPDATE_IC_IN_LISTING: 'UPDATE_IC_IN_LISTING',
    SET_HEADER_HEIGHT: 'SET_HEADER_HEIGHT',
    DELETE_ISSUE_COLLECTOR: 'DELETE_ISSUE_COLLECTOR',
    CHANGE_ISSUE_COLLECTOR_STATUS: 'CHANGE_ISSUE_COLLECTOR_STATUS',
	OPEN_CARDTYPE_SETTINGS: 'OPEN_CARDTYPE_SETTINGS',
    CLOSE_CARDTYPE_SETTINGS: 'CLOSE_CARDTYPE_SETTINGS',
    TOGGLE_MORE_INSTRUCTION: 'TOGGLE_MORE_INSTRUCTION',
    OPEN_OUTLOOK_SETTINGS: 'OPEN_OUTLOOK_SETTINGS',
    CLOSE_OUTLOOK_SETTINGS: 'CLOSE_OUTLOOK_SETTINGS'
};